export const datesRoutes = {
  create: [
    {
      path: 'dates',
      loadComponent: () =>
        import('./pages/initial-dates-step/initial-dates-step.component').then(
          (m) => m.InitialDatesStepPage,
        ),
    },
  ],
  view: [
    {
      path: 'dates',
      children: [
        {
          path: '',
          title: `trip dates`,
          loadComponent: () =>
            import('./pages/dates-section/dates-section.page').then((m) => m.DatesSectionPage),
        },
        {
          path: 'edit/:stage',
          title: `Edit dates configuration`,
          loadComponent: () =>
            import('./pages/dates-section/edit/edit.component').then(
              (m) => m.EditDatesConfigurationPage,
            ),
        },
      ],
    },
  ],
};
